var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("rect",{"x":".209","y":"69.017","width":"33.643","height":"17.014","rx":"4","key":0}),React.createElement("rect",{"x":"50.672","y":"69.017","width":"33.622","height":"17.014","rx":"4","key":1}),React.createElement("rect",{"x":".184","y":"34.99","width":"84.121","height":"17.014","rx":"4","key":2}),React.createElement("rect",{"x":".209","y":".964","width":"50.469","height":"17.013","rx":"4","key":3}),React.createElement("rect",{"x":"67.494","y":".964","width":"16.821","height":"17.013","rx":"4","key":4})]));
}

Icon.defaultProps = {"width":"85","height":"87","viewBox":"0 0 85 87"};

module.exports = Icon;

Icon.default = Icon;
